import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/freight/order/receipt/web/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 跟单
export function handleReceipt(data) {
  return request.send({
    url: `/pmy/freight/order/receipt/handle`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// WEB端--回单总览
export function getOverview(data) {
  return request.send({
    url: `/pmy/freight/order/receipt/web/overview`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

export function detailInfo(receiptId) {
  return request.send({
    url: `/pmy/freight/order/receipt/web/info?receiptId=${receiptId}`,
    method: "get"
  });
}
